// options passed to callback fetchEpisodes attach episodes modal
export const fetchEpisodesOptions = {
	sorted: { columnIndex: 0, type: 'asc' },
	accessor: 'number',
	filtered: { query: '', search_column: null },
	pageSize: null,
	page: 0,
	startIndex: 0
};
